import React from 'react';
import './FeaturesSection.css';
import { FaTshirt, FaTruck, FaClock, FaTags } from 'react-icons/fa';

const steps = [
  { icon: <FaTshirt />, title: "Expert Cleaning", desc: "Professional wash & dry for your delicate fabrics with care." },
  { icon: <FaTruck />, title: "Pickup & Delivery", desc: "Free door-to-door pickup and drop at your convenience." },
  { icon: <FaClock />, title: "Quick Turnaround", desc: "Same-day or next-day delivery options available." },
  { icon: <FaTags />, title: "Affordable Pricing", desc: "No hidden fees. Transparent rates for all services." },
];

const FeaturesSection = () => {
  return (
    <section className="zigzag-workflow-section">
      <h2 className="zigzag-title">Why Choose Us?</h2>
      <div className="zigzag-flow">
        {steps.map((step, index) => (
          <div className="zigzag-step" key={index}>
            <div className="circle">{step.icon}</div>
            <h4>{step.title}</h4>
            <p>{step.desc}</p>
            {index !== steps.length - 1 && <div className="connector" />}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
